<template>
  <div id="index" ref="appRef">
    <div class="city-bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body2">
        <div class="d-flex jc-center host-body-bg" v-if="!isBar">
          <div class="title" v-if="!title">
            <img src="../../assets/title.png" class="title-img" />
            <span class="title-text"
              >土拉宝（<span>{{ cityName }}</span
              >）调度中心</span
            >
          </div>
          <div class="title" v-else>
            <img :src="imageSrc" class="title-img" />
            <span style="font-size: 40px" class="title-text">{{ title }}</span>
          </div>
        </div>

        <!-- 第二行 -->
        <div class="time-div" v-if="!isBar">
          <div class="d-flex time-div-1">
            <span class="time-family">{{ year }} </span>年
            <span class="time-family">&nbsp;{{ month }} </span>月
            <span class="time-family">&nbsp;{{ day }} </span>日
            <span class="time-mag">
              <span class="time-family">{{ hour }}</span> :
              <span class="time-family">{{ minutes }}</span> :
              <span class="time-family">{{ seconds }}</span>
            </span>
            星期<span class="time-family">{{ dateWeek }}</span>
          </div>
        </div>

        <div class="body-box">
          <!-- 第三行数据 -->
          <div class="content-box">
            <!-- 左边 -->
            <div class="grid-container left-box">
              <waybill />
              <toDaySupplyChain />
              <project />
              <projectCar />
            </div>

            <!-- 中间 -->
            <div class="middle-box">
              <!-- 订单 -->
              <div class="order-box">
                <orderCount />
              </div>
              <!-- 地图 -->
              <div class="map-box">
                <cityMapVue />
              </div>
            </div>
            <!-- 右边 -->
            <div class="grid-container-right right-box">
              <!-- 运单信息 -->
              <waybillInfo />
              <!-- 用户规模 -->
              <userScale />
              <!-- 实时交易 -->
              <timeOrd />
              <!-- 用户动态 -->
              <userActive />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '../../utils/drawMixin'
import { formatTime } from '../../utils/index.js'
import { getInitAccessToken, getAccessToken } from '../../api/holdMy.js'
import { setToken, getToken } from '../../utils/getToken'
import { getUrlKey } from '../../utils'
import waybill from './waybill.vue' // 运单统计
import waybillInfo from './waybillInfo.vue' // 运单信息
import project from './project.vue' // 项目统计
import userScale from './userScale.vue' // 用户规模
import timeOrd from './timeOrd.vue' // 实时交易
import userActive from './userActive.vue' // 用户动态
import toDaySupplyChain from './toDaySupplyChain.vue'
import projectCar from './projectCar.vue'
import orderCount from './orderCount.vue'
import cityMapVue from './cityMap.vue'

export default {
  mixins: [drawMixin],
  data() {
    return {
      refreshTokening: null,
      timing: null,
      loading: true,
      dateWeek: '',
      weekday: ['日', '一', '二', '三', '四', '五', '六'],
      year: '',
      month: '',
      day: '',
      hour: '',
      minutes: '',
      seconds: '',
      cityName: '厦门',
      title: this.$route.query.title,
      isBar: this.$route.query.bar,
      imageSrc: '',
    }
  },
  components: {
    waybill,
    waybillInfo,
    project,
    toDaySupplyChain,
    timeOrd,
    userActive,
    userScale,
    orderCount,
    cityMapVue,
    projectCar,
  },
  mounted() {
    // 获取链接中的字段
    let cityName = getUrlKey('cityName')
    if (cityName !== null && cityName !== '') {
      this.cityName = cityName
      localStorage.setItem('cityName', cityName)
    } else {
      this.cityName = '厦门'
      localStorage.setItem('cityName', '厦门')
    }
    this.timeFn()
    this.cancelLoading()
    // 获取token
    this.GetInitAccessToken()
    // 定时刷新token
    this.GetAccessToken()
    this.imageSrc = require(`../../assets/${this.$route.query.title}.png`)
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    // 动态显示时间
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
        //年
        this.year = new Date().getFullYear()
        //月份是从0月开始获取的，所以要+1;
        var month = new Date().getMonth() + 1
        this.month = month < 10 ? '0' + month : month
        //日
        var day = new Date().getDate()
        this.day = day < 10 ? '0' + day : day
        var hour = new Date().getHours() // 时
        this.hour = hour < 10 ? '0' + hour : hour
        var minutes = new Date().getMinutes() // 分
        this.minutes = minutes < 10 ? '0' + minutes : minutes
        var seconds = new Date().getSeconds() //秒
        this.seconds = seconds < 10 ? '0' + seconds : seconds
      }, 1000)
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },

    // 初始化token
    GetInitAccessToken() {
      getInitAccessToken()
        .then((res) => {
          if (res.result == 0 && res.userdata && res.userdata.token) {
            setToken('holdpjToken', res.userdata.token)
            setToken('holdpjRefreshToken', res.userdata.refreshToken)
            this.loading = false
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    // 刷新token 30 * 57 * 1000 半个小时
    GetAccessToken() {
      this.refreshTokening = setInterval(() => {
        let data = {
          type: '2', // 传入用户id
          refreshToken: getToken('holdpjRefreshToken'),
        }
        getAccessToken(data)
          .then((res) => {
            if (res.result == 0 && res.userdata && res.userdata.token) {
              setToken('holdpjToken', res.userdata.token)
              setToken('holdpjRefreshToken', res.userdata.refreshToken)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      }, 30 * 57 * 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/index.scss';

.host-body2 {
  .host-body-bg {
    margin: 20px 0;
    width: 100%;
    height: 25px;
    background-image: url('../../assets/page_head.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .title {
    width: 750px;
    text-align: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;

    // margin: auto;
    .title-img {
      width: 72px;
      height: 72px;
      margin-right: 10px;
    }
    .title-text {
      vertical-align: middle;
      font-size: 48px;
      font-weight: 900;
      // position: absolute;
      // bottom: 0;
      // left:20%;
      // transform: translate(-13%);
      // text-align: center;
      font-family: '微软雅黑 Bold', 微软雅黑, sans-serif;
      font-weight: 700;
      font-style: normal;
      font-size: 36px;
      color: rgb(255, 255, 255);
    }

    .dv-dec-6 {
      position: absolute;
      bottom: -30px;
      left: 50%;
      width: 250px;
      height: 8px;
      transform: translate(-50%);
    }
  }

  // 第二行 时间
  .time-div {
    font-size: 20px;
    font-weight: 400;
    font-family: '300-CAI978', '300-CAI978', sans-serif;

    .time-mag {
      margin: 0 20px;
    }

    .time-div-1 {
      position: absolute;
      top: 7%;
      right: 0;
      transform: translate(-4%);
    }

    .time-family {
      color: #31a7ff;
    }
  }

  .body-box {
    margin-top: 40px;
    display: flex;
    flex-direction: column;

    //下方区域的布局
    .content-box {
      display: grid;
      grid-template-columns: 2fr 3.3fr 2fr;
      height: 100%;

      // 左边
      .left-box {
        width: 100%;

        .transport-box {
          display: flex;

          .flex-1 {
            width: 300px;
          }
        }

        .team-box {
          display: flex;
          height: 560px;
          margin-top: 20px;
        }

        .supply-box {
          height: 300px;
          margin-top: 22px;
        }
      }

      // 中间
      .middle-box {
        height: 950px;
        margin: 0 10px;

        .order-box {
          height: 100px;
        }

        .map-box {
          margin-top: 20px;
          height: 505px;
          // border: 1px solid rgb(17, 173, 20);
        }

        .motorcade-box {
          margin-top: 20px;
          height: 300px;
        }
      }

      // 右边
      .right-box {
        margin-top: 10px;
        height: 940px;

        .sys-box {
          height: 340px;
        }
      }
    }

    // 底部数据
    .bottom-box {
      margin-top: 10px;
      display: grid;
      grid-template-columns: repeat(2, 50%);
    }
  }
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* 两列等宽 */
  grid-template-rows: 300px auto;
  /* 第一行高度300px，第二行自适应 */
  gap: 16px 8px;
  /* 上下间隔为16px，左右间隔为8px */
}

.grid-container-right {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* 两列等宽 */
  grid-template-rows: 315px auto;
  /* 第一行高度315px，第二行自适应 */
  gap: 16px 8px;
  /* 上下间隔为16px，左右间隔为8px */
}
</style>
